import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import PortalPopup from "../../components/PortalPopup";
import DownloadModalTables from "../../components/DownloadModalTables";
import LawFirm from "../../components/LawFirm";
import DebtCollectionNav from "../../components/DebtCollectionNav";
import NavigationPanel from "../../components/NavigationPanel";
import CTAs from "../../components/CTAs";
import Footer from "../../components/Footer.js";

const OutcomeAndCostPage_1 = () => {
  const navigate = useNavigate();
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  const [isDownloadModalTablesOpen, setDownloadModalTablesOpen] =
    useState(false);
  const [isLawFirmOpen, setLawFirmOpen] = useState(false);
  const [isLawFirm1Open, setLawFirm1Open] = useState(false);
  const [isLawFirm2Open, setLawFirm2Open] = useState(false);
  const [isLawFirm3Open, setLawFirm3Open] = useState(false);
  const [isLawFirm4Open, setLawFirm4Open] = useState(false);

  const onClickCostImplication = useCallback(() => {
    navigate("/outcome&cost2");
  }, [navigate]);

  const onClickJudgementPhase = useCallback(() => {
    navigate("/outcome&cost3");
  }, [navigate]);

  const onClickClientCommunication = useCallback(() => {
    navigate("/outcome&cost4");
  }, [navigate]);

  const onClickReportingAndAnalytics = useCallback(() => {
    navigate("/outcome&cost5");
  }, [navigate]);

  const openLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(true);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const openDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(true);
  }, []);

  const closeDownloadModalTables = useCallback(() => {
    setDownloadModalTablesOpen(false);
  }, []);

  const openLawFirm = useCallback(() => {
    setLawFirmOpen(true);
  }, []);

  const closeLawFirm = useCallback(() => {
    setLawFirmOpen(false);
  }, []);

  const openLawFirm1 = useCallback(() => {
    setLawFirm1Open(true);
  }, []);

  const closeLawFirm1 = useCallback(() => {
    setLawFirm1Open(false);
  }, []);

  const openLawFirm2 = useCallback(() => {
    setLawFirm2Open(true);
  }, []);

  const closeLawFirm2 = useCallback(() => {
    setLawFirm2Open(false);
  }, []);

  const openLawFirm3 = useCallback(() => {
    setLawFirm3Open(true);
  }, []);

  const closeLawFirm3 = useCallback(() => {
    setLawFirm3Open(false);
  }, []);

  const openLawFirm4 = useCallback(() => {
    setLawFirm4Open(true);
  }, []);

  const closeLawFirm4 = useCallback(() => {
    setLawFirm4Open(false);
  }, []);

  const navItems = [
    {
      text: "Debt collection",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "",
      icon: "assets/arrow-down.svg",
    },

    {
      text: "Outcomes & costs",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
      icon: "",
    },

    {
      text: "AI indicators",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/ai1",
      icon: "",
    },
  ];

  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const claims = [
    {
      claimId: "1",
      status: "Successful",
      Outcome: "£10,000 recovered",
      action: "N/A",
    },
    {
      claimId: "2",
      status: "Unsuccessful",
      Outcome: "No recovery",
      action: "Contact law firm",
    },
    {
      claimId: "3",
      status: "Successful",
      Outcome: "£10,000 recovered",
      action: "N/A",
    },
    {
      claimId: "4",
      status: "Successful",
      Outcome: "£10,000 recovered",
      action: "N/A",
    },
    {
      claimId: "5",
      status: "Unsuccessful",
      Outcome: "No recovery",
      action: "Contact law firm",
    },
    {
      claimId: "6",
      status: "Successful",
      Outcome: "£10,000 recovered",
      action: "N/A",
    },
    {
      claimId: "7",
      status: "Successful",
      Outcome: "£10,000 recovered",
      action: "N/A",
    },
    {
      claimId: "8",
      status: "Unsuccessful",
      Outcome: "No recovery",
      action: "Contact law firm",
    },
    {
      claimId: "9",
      status: "Successful",
      Outcome: "£10,000 recovered",
      action: "N/A",
    },
    {
      claimId: "10",
      status: "Successful",
      Outcome: "£10,000 recovered",
      action: "N/A",
    },
  ];

  const filteredDebtors =
    activeTab === "all"
      ? claims
      : claims.filter(
          (debtor) => debtor.status.toLowerCase() === activeTab.toLowerCase()
        );

  const searchedDebtors = filteredDebtors.filter(
    (debtor) =>
      debtor.claimId.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.status.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.Outcome.toLowerCase().includes(searchQuery.toLowerCase()) ||
      debtor.action.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const statusColorMap = {
    Unsuccessful:
      "bg-semantics-high-high-50 text-semantics-high-high-500 border-semantics-high-high-500",
    Successful:
      "bg-semantics-low-low-50 text-semantics-low-low-500 border-semantics-low-low-500",
  };

  const statusIconMap = {
    Unsuccessful: "•",
    Successful: "•",
  };

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-base text-neutrals-neutral-900 font-open-sans-ff-meta-link">
        {/* Navigation Panel */}
        <NavigationPanel navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 text-Neutrals-neutral-900 px-4 md:px-4 lg:px-24 box-border">
          {/* Heading */}
          <b className="self-stretch relative text-9xl">{`Outcomes & costs`}</b>

          {/* Tab navigation */}
          <div className="self-stretch flex flex-row items-start justify-start gap-[24px] text-neutrals-neutral-300">
            <div className="bg-neutrals-neutral-50 box-border h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 text-primary-primary-500 border-b-[2px] border-solid border-primary-primary-500">
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Outcome updates</div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickCostImplication}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Cost implications</div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickJudgementPhase}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Judgement phase</div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickClientCommunication}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">
                  Client communication
                </div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickReportingAndAnalytics}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">{`Reporting & analytics`}</div>
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col items-start justify-start gap-6">
            <div className="self-stretch grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-center justify-start gap-6">
              {/* Block-1 */}
              <div className="w-full shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 border-neutrals-neutral-100 border-[1px] border-solid box-border flex flex-col items-start justify-start p-6 gap-6">
                <div className="self-stretch flex flex-row items-center justify-between">
                  <div className="relative font-semibold">Total recovered</div>
                </div>
                <div className="self-stretch h-20 flex flex-col items-start justify-between text-13xl">
                  <b className="relative">£100,000</b>
                  <div className="flex flex-row items-center justify-start gap-2.5 text-sm text-green-700">
                    <div className="flex flex-row items-center justify-start gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fill="#43934c"
                          d="M18.07 10.32c-.19 0-.38-.07-.53-.22L12 4.56 6.46 10.1c-.29.29-.77.29-1.06 0a.754.754 0 010-1.06l6.07-6.07c.29-.29.77-.29 1.06 0l6.07 6.07c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22z"
                        ></path>
                        <path
                          fill="#43934c"
                          d="M12 21.25c-.41 0-.75-.34-.75-.75V3.67c0-.41.34-.75.75-.75s.75.34.75.75V20.5c0 .41-.34.75-.75.75z"
                        ></path>
                      </svg>
                      <div className="relative font-semibold">20%</div>
                    </div>
                    <div className="relative font-semibold text-neutrals-neutral-300">
                      vs last month
                    </div>
                  </div>
                </div>
              </div>

              {/* Block-2 */}
              <div className="w-full shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-[1px] border-solid box-border flex flex-col items-start justify-start p-6 gap-6">
                <div className="self-stretch flex flex-row items-center justify-between">
                  <div className="relative font-semibold">Success rates</div>
                </div>
                <div className="self-stretch h-20 flex flex-col items-start justify-between text-13xl">
                  <b className="relative">85%</b>
                  <div className="flex flex-row items-center justify-start gap-2.5 text-sm text-green-700">
                    <div className="flex flex-row items-center justify-start gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fill="#43934c"
                          d="M18.07 10.32c-.19 0-.38-.07-.53-.22L12 4.56 6.46 10.1c-.29.29-.77.29-1.06 0a.754.754 0 010-1.06l6.07-6.07c.29-.29.77-.29 1.06 0l6.07 6.07c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22z"
                        ></path>
                        <path
                          fill="#43934c"
                          d="M12 21.25c-.41 0-.75-.34-.75-.75V3.67c0-.41.34-.75.75-.75s.75.34.75.75V20.5c0 .41-.34.75-.75.75z"
                        ></path>
                      </svg>
                      <div className="relative font-semibold">40%</div>
                    </div>
                    <div className="relative font-semibold text-neutrals-neutral-300">
                      vs last month
                    </div>
                  </div>
                </div>
              </div>

              {/* Block-3 */}
              <div className="w-full shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-bg-primary border-neutrals-neutral-100 border-[1px] border-solid box-border flex flex-col items-start justify-start p-6 gap-6">
                <div className="self-stretch flex flex-row items-center justify-between">
                  <div className="relative font-semibold">
                    Successful claims
                  </div>
                </div>
                <div className="self-stretch h-20 flex flex-col items-start justify-between text-13xl">
                  <b className="relative">70</b>
                  <div className="flex flex-row items-center justify-start gap-2.5 text-sm text-green-700">
                    <div className="flex flex-row items-center justify-start gap-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fill="#43934c"
                          d="M18.07 10.32c-.19 0-.38-.07-.53-.22L12 4.56 6.46 10.1c-.29.29-.77.29-1.06 0a.754.754 0 010-1.06l6.07-6.07c.29-.29.77-.29 1.06 0l6.07 6.07c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22z"
                        ></path>
                        <path
                          fill="#43934c"
                          d="M12 21.25c-.41 0-.75-.34-.75-.75V3.67c0-.41.34-.75.75-.75s.75.34.75.75V20.5c0 .41-.34.75-.75.75z"
                        ></path>
                      </svg>
                      <div className="relative font-semibold">15%</div>
                    </div>
                    <div className="relative font-semibold text-neutrals-neutral-300">
                      vs last month
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] flex flex-col items-start justify-start text-sm">
              <div className="w-full rounded-t-3xs rounded-b-none border-neutrals-neutral-100 border-t-[1px] border-r-[1px] border-solid border-l-[1px] box-border flex flex-row items-center justify-between py-5 px-6 text-lg">
                <div className="flex flex-row items-center justify-start gap-2.5">
                  <div className="relative font-semibold">Claim details</div>
                  <div className="rounded-[5px] bg-bg-primary border-neutrals-neutral-100 border-[1px] border-solid flex flex-row items-center justify-start py-0.5 px-2 gap-1.5 text-sm">
                    <div className="w-1.5 relative rounded-[50%] bg-primary-primary-500 h-1.5" />
                    <div className="relative font-semibold">10 claims</div>
                  </div>
                </div>
                <CTAs
                  type="Secondarybtn"
                  text="Download"
                  borderColor="border-neutrals-neutral-100"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M9 11v6l2-2M9 17l-2-2"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M22 10v5c0 5-2 7-7 7H9c-5 0-7-2-7-7V9c0-5 2-7 7-7h5"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                      <path
                        d="M22 10h-4c-3 0-4-1-4-4V2l8 8Z"
                        stroke="#2d404e"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  }
                  position="relative"
                  onClick={openDownloadModalTables}
                />
              </div>

              {/* Filters */}
              <div className="w-full box-border flex flex-row items-center justify-between py-3 px-6 border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-l-[1px]">
                <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-start border-[1px] border-solid border-neutrals-neutral-100">
                  <button
                    onClick={() => setActiveTab("all")}
                    className={`rounded-tl-3xs rounded-tr-none rounded-br-none rounded-bl-3xs px-4 py-2 text-sm font-medium rounded-md  bg-column-bg flex flex-row items-center justify-center border-r-[1px] border-solid border-neutrals-neutral-100 ${
                      activeTab === "all"
                        ? "bg-neutrals-neutral-50"
                        : "text-neutrals-neutral-900 hover:bg-column-bg"
                    }`}
                  >
                    <div className="relative font-semibold">View all</div>
                  </button>
                  <button
                    className={`flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-solid border-neutrals-neutral-100 bg-white ${
                      activeTab === "Successful"
                        ? "bg-white"
                        : "text-neutrals-neutral-900 hover:bg-column-bg"
                    }`}
                    onClick={() => setActiveTab("Successful")}
                  >
                    <div className="relative font-semibold">Successful</div>
                  </button>
                  <button
                    className={`rounded-tl-none rounded-tr-3xs rounded-br-3xs rounded-bl-none flex flex-row items-center justify-center py-2 px-4 bg-neutrals-neutral-50 ${
                      activeTab === "Unsuccessful"
                        ? "bg-neutrals-neutral-50"
                        : "text-neutrals-neutral-900 hover:bg-column-bg"
                    }`}
                    onClick={() => setActiveTab("Unsuccessful")}
                  >
                    <div className="relative font-semibold">Unsuccessful</div>
                  </button>
                </div>
                <div className="flex flex-row items-start justify-start text-neutrals-neutral-300">
                  <div className="w-[294px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-row items-center justify-start py-2.5 px-3.5 border-[1px] border-solid border-neutrals-neutral-100">
                    <div className="flex flex-row items-center justify-start gap-[10px]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M11.5 21a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19ZM22 22l-2-2"
                          stroke="#2d404e"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </svg>
                      <div className="relative">Search your claims</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Main table */}
              <div className="w-full flex flex-col items-start justify-start">
                <div className="w-full flex flex-col items-start justify-start">
                  <div className="self-stretch flex flex-row items-start justify-start">
                    <table className="min-w-full divide-y divide-gray-200 border-collapse">
                      <thead className="bg-column-bg">
                        <tr>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-l-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Claim id
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Status
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Outcome
                          </th>
                          <th
                            scope="col"
                            className="items-start justify-start py-3 px-4 border-t-[1px] border-b-[1px] border-r-[1px] border-solid border-neutrals-neutral-100 font-open-sans-ff-meta-strong"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-neutrals-neutral-50 divide-y divide-gray-200">
                        {searchedDebtors.map((claims) => (
                          <tr key={claims.id} className="hover:bg-gray">
                            <td className="p-4 items-start border-solid border-b-[1px] border-l-[1px] border-neutrals-neutral-100">
                              {claims.claimId}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100 whitespace-nowrap">
                              <span
                                className={`px-2 py-0.5 text-xs font-semibold rounded-full border-solid border-[1px] border-current ${
                                  statusColorMap[claims.status]
                                }`}
                              >
                                <span className="mr-1">
                                  {statusIconMap[claims.status]}
                                </span>
                                {claims.status}
                              </span>
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-neutrals-neutral-100">
                              {claims.Outcome}
                            </td>
                            <td className="p-4 items-start border-solid border-b-[1px] border-r-[1px] border-neutrals-neutral-100">
                              <a
                                className="text-primary-primary-500"
                                href="#"
                                onClick={openLawFirm}
                              >
                                {claims.action}
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              <div className="w-full rounded-t-none rounded-b-3xs box-border flex flex-row items-center justify-between shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] pt-3 px-6 pb-4 border-r-[1px] border-solid border-neutrals-neutral-100 border-b-[1px] border-l-[1px]">
                <CTAs
                  type="Secondarybtn"
                  text="Previous"
                  borderColor="border-neutrals-neutral-100"
                />
                <div className="relative">Page 1 of 10</div>
                <CTAs
                  type="Secondarybtn"
                  text="Next"
                  borderColor="border-neutrals-neutral-100"
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
      {isDownloadModalTablesOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeDownloadModalTables}
        >
          <DownloadModalTables onClose={closeDownloadModalTables} />
        </PortalPopup>
      )}
      {isLawFirmOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm}
        >
          <LawFirm onClose={closeLawFirm} />
        </PortalPopup>
      )}
      {isLawFirm1Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm1}
        >
          <LawFirm onClose={closeLawFirm1} />
        </PortalPopup>
      )}
      {isLawFirm2Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm2}
        >
          <LawFirm onClose={closeLawFirm2} />
        </PortalPopup>
      )}
      {isLawFirm3Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm3}
        >
          <LawFirm onClose={closeLawFirm3} />
        </PortalPopup>
      )}
      {isLawFirm4Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLawFirm4}
        >
          <LawFirm onClose={closeLawFirm4} />
        </PortalPopup>
      )}
    </>
  );
};

export default OutcomeAndCostPage_1;
